export const htmlElements = [
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'p',
    'span',
    'strong',
    'b',
    'em',
    'i',
    'q',
    'mark',
    'sub',
    'sup',
    'time',
    'figcaption',
];
export const fontWeights = ['normal', 'bold'];
export const textVariants = [
    'copy1',
    'copy2',
    'copy3',
    'order1',
    'order2',
    'order3',
    'order4',
    'display1',
    'display2',
];
//# sourceMappingURL=Text.types.mjs.mjs.map